import React from 'react'
import { IonIcon } from '../views/ionicon/IonIcon'

const LoadingPage = props => (
  <section className="hero is-fullheight is-info is-bold">
    <div className="hero-body">
      <div className="container">
        <span className="icon is-large">
          <IonIcon name="book" size="3x-lg" />
        </span>
        <h1 className="title">LOADING</h1>
        <h2 className="subtitle">Please wait...</h2>
      </div>
    </div>
  </section>
)

export default LoadingPage



// WEBPACK FOOTER //
// ./src/components/pages/LoadingPage.js